import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { DocumentCopy } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'ClipboardText',
  props: {
    text: {}
  },
  setup(__props: any) {


const props = __props

const handleCopyToClipboard = () => {
  if (props.text) {
    navigator.clipboard.writeText(props.text)
    ElMessage.success({ type: 'success', message: 'Текст скопирован в буфер обмена' })
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_text = _resolveComponent("el-text")!

  return (_openBlock(), _createBlock(_component_el_text, null, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(props.text) + " ", 1),
      _createVNode(_component_el_button, {
        type: "text",
        onClick: handleCopyToClipboard,
        style: {"margin-left":"12px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(DocumentCopy))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})